import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

const { div, p, br } = hh(h);
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Loading from '../Loading';

function CourseSuccess({ data: { loading, submission }, ...props }) {
    if (loading) {
      return h(Loading);
    } else {
        return (
            div([
                p([
                    `Hey ${submission.user.firstName}!`,
                    br(),
                    `Thank you for submitting your interest for the upcoming ${submission.course.name} course at ${submission.course.university.name}!`,
                    br(),
                    'We will get back to you super soon!'
                ])
            ])
        );
    }
}

export default graphql(gql`
    query($submissionId: String!){
        submission(id: $submissionId) {
            id
            state

            course {
                id
                name
                daysToPay
                price

                university {
                    name
                }
            }
            user {
                id
                firstName
                lastName
                email
            }
        }
    }
`, {
    options({ params: { submissionId }}) {
        return { variables: { submissionId: submissionId }};
    }
})(CourseSuccess);



/** WEBPACK FOOTER **
 ** ./src/CourseSuccess/index.js
 **/